/**
 * Deletion Policy Config Schema
 *
 * Stored in SystemConfig under category="deletion", one row per entity:
 *   - key="agent.policy"      → applies to Agent deletion
 *   - key="deployment.policy" → applies to Deployment deletion
 *
 * Modes:
 *   - SOFT: set deletedAt on the row, fully reversible via restore endpoint
 *   - HARD: snapshot a tombstone row, hard-delete the original, FK SetNull
 *           cascades preserve history-bearing children
 *
 * Default is SOFT for both. The setting is system-wide (not per-org).
 */

import { z } from "zod";

export const DELETION_MODES = ["SOFT", "HARD"] as const;

export const DeletionModeSchema = z.enum(DELETION_MODES);

export type DeletionMode = z.infer<typeof DeletionModeSchema>;

export const DeletionPolicyConfigSchema = z.object({
  mode: DeletionModeSchema
});

export type DeletionPolicyConfig = z.infer<typeof DeletionPolicyConfigSchema>;
